export function copyToClipboard(textToCopy: string) {
  try {
    navigator.clipboard.writeText(textToCopy);
  } catch (err) {
    console.error('Unable to copy text to clipboard.', err);
  }
}
